import {
  Grid,
  Tabs,
  Tab,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Grow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import React, {useState} from 'react';
import ImageGallery from '../../components/ImageGallery/ImageGallery';
import resumeData from '../../utils/resumeDate';
import './style.js';
import useStyles from './style.js';

const Portfolio = () => {
  const classes = useStyles ();

  const [tabValue, setTabValue] = useState ('All');
  const [projectDialog, setProjectDialog] = useState (false);

  return (
    <Grid conatiner spacing={1} className={classes.section}>

      {/* Title */}
      <Grid item className={classes.sectionTitle}>
        <span className={classes.span} />
        <h6 className={classes.sectionTitleText}>Portfolio</h6>
      </Grid>

      {/* Tabs */}
      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          indicatorColor="white"
          className={classes.customTabs}
          onChange={(e, newValue) => setTabValue (newValue)}
        >
          <Tab
            label="ALL"
            value="All"
            className={
              tabValue === 'All' ? 'customTabsItemActive' : 'customTabsItem'
            }
          />

          {[
            ...new Set (resumeData.projects.map (item => item.tag)),
          ].map (tag => (
            <Tab
              label={tag}
              value={tag}
              className={
                tabValue === tag ? 'customTabsItemActive' : 'customTabsItem'
              }
            />
          ))}
        </Tabs>
      </Grid>

      {/* Projects */}
      <Grid item xs={12}>
        <Grid container spacing={3}>
          {resumeData.projects.map (project => (
            <>
              {tabValue === project.tag || tabValue === 'All'
                ? <Grid item xs={12} lg={4}>
                    <Grow in timeout={1000}>
                      <Card
                      style={{backgroundColor: "#1a202c", color: '#808d9f'}}
                        onClick={() => setProjectDialog (project)}
                        className={classes.customCard}
                      >
                        <CardActionArea>
                          <CardMedia
                            className={classes.customCardImage}
                         >
                           <img alt="project" width="100%" height="150px" src={project.image} />
                         </CardMedia>
                          <CardContent style={{ display: "flex", flexDirection: 'column', alignItems: "center"}}>
                            <Typography className={classes.customCardTitle}>
                              {project.title}
                            </Typography>
                            <Typography
                              variant="body2"
                              className={classes.customCardCaption}
                            >
                              {project.caption}
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Grow>
                  </Grid>
                : null}
            </>
          ))}
        </Grid>
      </Grid>

      <Dialog 	 style={{width:'70wh', borderRadius: 20}} fullWidth  open={projectDialog} onClose={ ()=> setProjectDialog(false)}>
        <DialogTitle className={classes.dialogTitle} onClose={ ()=> setProjectDialog(false)}>
         {projectDialog.title}
        </DialogTitle>
        
        <DialogContent  className={classes.dialog}> 
        {projectDialog.images &&
            <ImageGallery images={projectDialog.images} />}
          <Typography className={classes.dialogDescription}>  {projectDialog.description1}</Typography>
          <Typography className={classes.dialogDescription}>  {projectDialog.description2} <br></br> {projectDialog.description3}</Typography>
        </DialogContent>

        <DialogActions className={classes.dialog} >
        {projectDialog?.links?.map(link => (
           
              <Button className={classes.dialogIcon}  href={link.link}  target="_blank"> {link.icon} </Button>
           
          
        ))}
         
        </DialogActions>
    </Dialog>

    </Grid>
  );
};

export default Portfolio;
